import React from 'react';
export function Footer() {
  return <footer className="w-full bg-paper px-5 py-10" data-id="element-84" data-mp="32wmqrybuniwl">
      <div className="mx-auto max-w-2xl text-center" data-id="element-85" data-mp="3gfsoch60l2p3">
        <p className="font-serif-display text-base font-semibold text-ink" data-id="element-86" data-mp="3ghc3u5juj9pt">CHIMICA VISIVA™</p>
        <p className="mt-2 text-xs leading-relaxed text-ink/50" data-id="element-87" data-mp="32pp4txyirn3c">
          Prodotto digitale · Nessuna spedizione fisica
          <br data-id="element-88" data-mp="36n3gdw9oa6yi" />
          Pagamento unico · Nessun abbonamento
          <br data-id="element-89" data-mp="3ufjwi19unov6" />
          Licenza individuale per l’utilizzo nelle proprie classi. La redistribuzione, la condivisione
          integrale, la modifica finalizzata alla rivendita e la vendita dei materiali non sono
          consentite.
        </p>
        <p className="mt-4 text-xs text-ink/40" data-id="element-90" data-mp="3qd6r5dz0lsyx">
          Le illustrazioni e i modelli possono essere semplificati per finalità didattiche. Formule,
          valori, unità e spiegazioni scritte costituiscono il riferimento scientifico.
        </p>
        <p className="mt-4 text-xs text-ink/40" data-id="element-91" data-mp="2ezuvvrhbmiod">
          © 2026 CHIMICA VISIVA™ by THE RESOURCE LAB. Tutti i diritti riservati.
        </p>
      </div>
    </footer>;
}